/**
 * Mapping the key (language or locale) to the exists locale file.
 * All supported locales (locale files names) should be defined (as key or value)
 * The language: in == id (Java specific)
 */
export const lcOptions = {
  options: {
    defaultLocaleName: 'en-US',
    queryLocaleParamName: 'lang',
    queryLocaleResolving: true,
    cookieLocaleResolving: true,
    browserLocaleResolving: true,
    cookieSaveActiveLocale: true
  },
  mapping: {
    'bg': 'bg-BG',
    'cs': 'cs-CZ',
    'da': 'da-DK',
    'de': 'de-DE',
    'en': 'en-US',
    'es': 'es-ES',
    'fi': 'fi-FI',
    'fr': 'fr-FR',
    'hu': 'hu-HU',
    'id': 'id-ID',
    'in': 'id-ID',
    'it': 'it-IT',
    'ja': 'ja-JP',
    'ko': 'ko-KR',
    'ms': 'ms-MY',
    'nb': 'nb-NO',
    'nl': 'nl-NL',
    'pl': 'pl-PL',
    'pt': 'pt-PT',
    'pt-BR': 'pt-BR',
    'ru': 'ru-RU',
    'sr': 'sr-RS',
    'sv': 'sv-SE',
    'tr': 'tr-TR',
    'zh': 'zh-CN',
    'zh-SG': 'zh-CN',
    'zh-HK': 'zh-TW',
    'zh-MO': 'zh-TW'
  },
  global: {
    'login-page.link.forgot-password': 'https://account.acronis.com/#/auth/password/reset',
    'account-page.link.manage-subscription': 'https://account.acronis.com',
    'wrh.main-page.link.user-help.mac': 'https://go.acronis.com/documentation/ATIMAC',
    'wrh.main-page.link.user-help.win': 'https://go.acronis.com/documentation/ATI',
    'wre.main-page.link.user-help': 'https://go.acronis.com/documentation/AcronisBackup',
    'wrh.shared-link.link.install-atih': 'https://www.acronis.com/personal/computer-backup',
    'wrh.shared-link.link.install-atih.android': 'https://play.google.com/store/apps/details?id=com.acronis.acronistrueimage',
    'wrh.shared-link.link.install-atih.ios': 'https://apps.apple.com/app/id978342143',
    'wre.shared-link.link.install-cb': 'https://www.acronis.com/en-us/business/backup',
    'wre.shared-link.link.install-cb.android': 'https://play.google.com/store/apps/details?id=com.acronis.abc',
    'wre.shared-link.link.install-cb.ios': 'https://apps.apple.com/us/app/acronis-backup/id1118448159',
    'wr.notary-certificate.link.etherscan': 'https://etherscan.io/',
    'wr.notary-certificate.link.notary-merkling': 'https://blog.ethereum.org/2015/11/15/merkling-in-ethereum/',
    'wr.notary-certificate.link.validate-js': 'https://github.com/chainpoint/chainpoint-validate-js'
  }
};
